import { sampleSize } from 'lodash';
import Definition from '@src/icons/prompt/definitions.svg';
import Analysis from '@src/icons/prompt/analysis.svg';
import Capability from '@src/icons/prompt/capabilities.svg';
import BestPractice from '@src/icons/prompt/best-practices.svg';
import { DASHBOARD_TYPE, CURRENT_PRODUCT_MODE } from '@utils/constants';

export const CATEGORY_ICON_MAP = {
  Definitions: Definition,
  'Best Practices': BestPractice,
  Analysis,
  Capabilities: Capability,
};

export const NUMBER_OF_QUESTIONS_PER_SECTION = 3;

export const TIMELINE_SUMMARY_QUESTION = '__From ECO1 Timeline Summary__';

export const VIDEO_SUMMARY_QUESTION = '__From VIDEO Viewer Module Summary__';

export const QUESTIONS_SECTIONS = [
  {
    title: 'Analysis',
    questions: [
      'Provide the Video Playback Failures (VPF) rate by Device Name for live events in the last 2 hours.',
      'Show the Streaming Performance Index (SPI) on Chromecast last week.',
      'What were the Minutes Played Per Ended Plays by Device Name in the last 6 hours?',
      'How many App Screen Loads were recorded by Cities today?',
      'How many App Total Events were recorded by Device Name this week?',
      'How many App Screen Loads were recorded by Device Name  yesterday?',
      'Show the Video Start Failures Tech (VSF-T) rate by Continents in the last month.',
      'Give me the App Average Page Load Time by Zipcode in the last 6 hours.',
      'What was the App Average Network Request Duration on PC in the last 7 days?',
      'What was the Average Peak Bitrate by Device Name in the last 30 days?',
      'How many Concurrent Plays were recorded over the past month?',
      'Provide the Streaming Performance Index (SPI) by Cities in the last 7 days.',
      'Provide the Video Playback Failures (VPF) rate by Title this week.',
      'How many Video Start Failures (VSF) occurred by CDN in the last 6 hours?',
      'How many Unique Devices with Ended Plays were recorded by Title in the last 24 hours?',
      'How many Concurrent Plays were recorded by Device Name in the last 24 hours?',
      'How many Video Start Failures (VSF) occurred by Device Name in the last 2 hours?',
      'What was the App Average Network Request Duration by App Name in the last 30 days?',
      'What was the App Average Minutes Per Page by Device Name?',
      'How many Concurrent Plays were recorded by Device Name last week?',
      'Show the Rebuffering Ratio by  Title in the last 24 hours.',
      'How many App Page Loads were recorded by Device Name in the last 6 hours?',
      'Give me the Average Bitrate by Device Name in the last 30 days.',
      'Provide the Rebuffering Ratio by Device Name yesterday.',
      'Provide the Average Peak Bitrate on Android TV in the last 2 hours.',
      'How many Video Playback Failures Business (VPF-B) occurred by Device Name last week?',
      'Show the Streaming Performance Index (SPI) by Device Name in the last 30 days.',
      'Provide the App Service Performance Index by Device Name last week.',
      'How many Exits Before Video Start occurred by Device Name in the last 2 hours?',
      'How many App Active Devices were recorded in the last month?',
      'What was the App Average Screen Load Time by Device Name last week?',
      'Show the Average Peak Bitrate on Xbox One in the last 2 hours.',
      'What was the App Average Network Request Duration by Device Name in the last 6 hours?',
      'Provide the Video Start Failures Business (VSF-B) rate by Continents in the last 24 hours.',
      'How many App Page Loads occurred by Platforms this week?',
      'How many App Screen Loads were recorded by Device Name in the last month?',
      'How many App Active Devices were recorded by Cities in the last 2 hours?',
      'Provide the Video Playback Failures (VPF) rate for Mac devices in the last 6 hours.',
      'How many Concurrent Plays were recorded by Device Name in the last month?',
      'Give me the Streaming Performance Index (SPI) by Cities last week.',
      'Show the Video Start Failures Business (VSF-B) rate by Device Name in the last 24 hours.',
      'How many App Active Devices were recorded by Device Name in the last 6 hours?',
      'Show the Video Playback Failures (VPF) rate this week.',
      'How many App Screen Loads were recorded over the past month?',
      'Give me the App Average Screen Load Time for Android Phome in the last 24 hours.',
      'Provide the Streaming Performance Index (SPI) for PlayStation 4 over the past month.',
      'Show the App Average Screen Load Time  in the last 7 days.',
      'Provide the Streaming Performance Index (SPI) by CDNs in the last 30 days.',
      'What was the Average Peak Bitrate by Browser Name in the last 2 hours?',
      'How many Unique Devices with Ended Plays were recorded by Device Name yesterday?',
      'How many App Page Loads occurred by Device Name in the last week this month?',
      'Provide the Average Peak Bitrate by Device Name this week.',
      'What was the App Average Network Request Duration last week?',
      'What was the App Average Minutes Per Page by Zipcode in the last 7 days?',
      'How many Unique Devices with Ended Plays were recorded by CDN in the last month?',
      'Show the Rebuffering Ratio for PlayStation 4 in the last month.',
      'How many App Active Users were recorded by Device Name last week?',
      'Show the Rebuffering Ratio by CDNs yesterday.',
      'What were the Minutes Played Per Ended Plays on Android Tablet in the last 24 hours?',
      'Provide the Video Playback Failures Tech (VPF-T) rate for LG TV yesterday.',
      'What was the App Average Network Request Duration on Mac yesterday?',
      'How does the Video Playback Failures (VPF) rate vary by Device Name this week?',
      'What was the App Average Network Request Duration by Device Name in the last 2 hours?',
      'How many Video Playback Failures Business (VPF-B) occurred by Countries in the last 7 days?',
      'What was the App Average Network Request Duration by App Name last month?',
      'How many Exits Before Video Start occurred by Browser Name this week?',
      'Show the Streaming Performance Index (SPI) trend by Device Name over the past month.',
      'Provide the App Service Performance Index for Apple iPad over the past month.',
      'How many Video Start Failures (VSF) occurred yesterday?',
      'How many App Active Devices were recorded on Android Tablet in the last 24 hours?',
      'What was the EBVS rate today?',
      'How many App Total Events were recorded by Platforms in the last 2 hours?',
      'Provide the App Average Screen Load Time for Android Phone in the last 7 days.',
      'Give me the App Average Page Load Time by Device Name in the last 2 hours.',
      'Give me the App Average Page Load Time yesterday.',
      'How many Concurrent Plays were recorded by Title in the last 30 days?',
      'Give me the Streaming Performance Index (SPI) for Roku devices over the past month.',
      'Show the Exits Before Video Start by Title in the last 6 hours.',
      'What was the Streaming Performance Index (SPI) on Android Phone last month?',
      'Show the Video Playback Failures Tech (VPF-T) rate by Countries yesterday.',
      'How many App Active Users were recorded by Device Name over the past month?',
      'What was the App Average Minutes Per Page by Platform yesterday?',
      'How many App Total Events were recorded yesterday?',
      'What was the App Average Minutes Per Page on Apple iPhone Web last week?',
      'Provide the Exits Before Video Start rate for Apple iPad in the last 6 hours.',
      'How many App Active Users accessed the app by Browser Name in the last 30 days?',
      'Give me the Network Request Count by Device Name in the last 7 days.',
      'Show the Streaming Performance Index (SPI) by Title in the last 7 days.',
      'Provide the Rebuffering Ratio for content streamed on Apple TV in the last month.',
      'Provide the Streaming Performance Index (SPI) by Title last week.',
      'How many App Screen Loads were recorded by Device Name in the last 24 hours?',
      'How many Video Start Failures (VSF) occurred by Browser Name this week?',
      'Provide the Rebuffering Ratio by Device Name in the last 24 hours.',
      'How many App Active Users accessed the app via Apple iPhone in the last 7 days?',
      'Give me the App Service Performance Index by Page Title in the last month.',
      'How many Concurrent Plays were recorded in the last 7 days?',
      'Show the Video Start Failures Tech (VSF-T) rate for Roku devices this week.',
      'How many Exits Before Video Start occurred on Apple iPhone Web in the last 6 hours?',
    ],
  },
  {
    title: 'Definitions',
    questions: [
      // video domain
      'What is SPI?',
      'What is the meaning of -T in VPF-T?',
      'How can I find the devices that are contributing most to VSF-T?',
      'How do we address unknown CDNs in Pulse?',
      'What is Zero CIRR?',
      'What is the difference between Content Category and Content Type?',
      'How is VST measured?',
      'What are the different time granularities for live, one day, 7 days, or more?',
      'If sessions are set to "Yes" on Impacted Session column in the Viewer dashboard what does that mean?',
      'Are we able to identify sessions and associated viewer IDs in Pulse?',
      'Do Concurrent Plays include paused time?',
      'What is Abandonment?',
      // app domain
      'What is the difference between App Session Metrics and App Interval Metrics?',
      'What is auto-collected by the App Sensor?',
      'What devices are supported with App Sensor?',
      'What is App analytics?', // todo need to check prompt ai
      'What App metrics are supported?',
      'What is Semantic Mapper for App?',
      'What is App Metric Builder?',
      // ad domain
      'What does "% Slate Duration" indicate in ad analytics and how does it impact ad revenue?',
      'How is "% Slate Plays" different from "% Slate Duration" and what does it tell us about ad performance?',
      'What does "Ads Completed (% of Ad Impressions)" reveal about viewer engagement with ads?',
      'How is "Ad Actual Duration" calculated and what insights does it offer?',
      'What do "Ad Attempts" signify in the context of ad delivery and success rate?',
      'How does "Ad Average Bitrate" affect the quality of ad experience?',
      'What is the significance of "Ad Concurrent Plays" in real-time ad analytics?',
      'How can "Ad Frequency/Unique" help in optimizing ad campaigns for better viewer experience?',
      'What insights can "Ad Impressions (% of Attempts)" provide about ad delivery efficiency?',
      'What does "Ad Rebuffering Ratio" indicate about ad streaming quality and viewer experience?',
    ],
  },
  {
    title: 'Best Practices',
    questions: [
      // video domain
      'How do I improve Video Baseline Performance?',
      'What is Real-Time Monitoring in Conviva for Video?',
      'How can I be alerted automatically for a Video incident or outage? ',
      'How can I benchmark video performance so I know customers are getting the experience they expect?',
      'How can I track New App Version Releases in Video & Media players?',
      'How can I integrate Conviva video instrumentation in a new device?',
      'How do I manage Conviva Device Integrations for Video and Media?',
      // app domain
      'How do I integrate Conviva App Sensor? ',
      'What are the steps for mapping new app events?',
      // ad domain
      'How do I monitor ad performance in real-time using the Ad Experience Dashboard?',
      'What features does the Ad Experience Dashboard offer for analyzing and diagnosing ad performance?',
      'How can I monitor and analyze ad creative performance across different browser versions?',
    ],
  },
  {
    title: 'Capabilities',
    questions: [
      // video domain
      'What are the newest Video features and functionalities?',
      'What are the most important Video metrics?',
      'What are some tips for Video Trends Analytics Workflows?',
      'How does Pulse automatically surface key insights into these datasets?',
      'How does Pulse help me operationalize data across my org through visualization?',
      'How does Pulse enable video and media monitoring in real-time?',
      'How can I see a whole timeline of a video session?',
      'What are the thresholds for Video SPI?',
      'What is CONVIVA_INTERNAL_UNKNOWN?',
      'How do I enable Custom tags as dimensions in Pulse Video Trends?',
      'When I log into Conviva why does it take me to my profile page?',
      'Why are AI Alerts not firing, is there a minimum amount of traffic needed?',
      // app domain
      'How is drill-down analysis performed in App analytics?', // todo need to check prompt ai
      'What insights can be gained from viewing the App User Timeline?',
      'What kind of analytics capabilities are essential in RUM solutions for optimizing app user experience?',
      'How do RUM solutions help in understanding and improving app user engagement? ',
      'What are common use cases for analyzing app user engagement?',
      'What is Real-Time Monitoring in Conviva for App?',
      'How can I be alerted automatically for an App incident or outage?',
      // ad domain
      'How can I navigate through the Ad Experience interface effectively?',
      'What are the key features of the Ad Experience dashboards?',
      'How do I change the default landing page in the Ad Experience interface?',
      'How can I use filters for more focused analysis in the Ad Experience interface?',
      'Is there a way to export data from the Ad Experience dashboards?',

      // Roles part
      // video domain
      'What dashboards and metrics are most important for a Media & Entertainment executive?',
      'What dashboards are most common for a Video Product Lead?',
      'What are typical data-driven techniques for Video Engineering/Ops/IT?',
      'How can Customer Care in Media & Entertainment utilize Conviva?',
      'How can Video Data Science & Analytics Team expand Conviva data utilization?',
      'How do Video App Developers use Conviva?',
      // app domain
      'Who benefits from using App analytics?', // todo need to check prompt ai
      'Who is the typical owner involved in setting up and using Semantic Mapper and Metric Builder for App?',
      'What dashboards and metrics are most important for an App executive?',
      'What are typical data-driven techniques for App Engineering/Ops/IT?',
      // ad domain
      'What are some typical job titles and job functions for users of an Ad Experience dashboard?',
    ],
  },
];

export function getRandomisedQuestions(filteredQuestions, noOfQuestions) {
  return filteredQuestions.map(({ title, questions }) => {
    return {
      title,
      questions: sampleSize(questions, noOfQuestions),
    };
  });
}

export function getBotAnswerText(botData) {
  return (botData || [])
    .filter((item) => item.type === 'markdown')
    .map((item) => item.text)
    .join('');
}

export function botAnswerHasMetricData(botData) {
  return (botData || []).some((item) => item.type === 'metricChart');
}

export function botAnswerHasDimensionData(botData) {
  return (botData || []).some((item) => item.type === 'dimensionTable');
}

export const drillDownDashboardType = {
  AI: DASHBOARD_TYPE.TRENDS_DRILLDOWN,
  EI: DASHBOARD_TYPE.TRENDS_DRILLDOWN,
  APP: DASHBOARD_TYPE.APP_EXPERIENCE_DRILLDOWN,
}[CURRENT_PRODUCT_MODE];

export const defaultDimensions = {
  EI: ['channel', 'OBJECT_NAME', 'GEO_DMA', 'GEO_CITY'],
  AI: ['OBJECT_NAME', 'GEO_STATE', 'GEO_COUNTRY'],
  APP: ['app_id', 'platform', 'device_name', 'geo_country'],
}[CURRENT_PRODUCT_MODE];
